<template>
  <canvas class="canvas-fav" width="16" height="16"></canvas>
</template>

<script>
export default {
  name: 'Favicon',

  data() {
    return {
      index: 0,
      speed: 300,
    };
  },

  mounted() {
    const canvas = this.$el;

    canvas.width = 32;
    canvas.height = 32;
    canvas.style.width = '16px';
    canvas.style.height = '16px';

    const ctx = canvas.getContext('2d');
    ctx.scale(2, 2);
    ctx.globalCompositeOperation = 'source-over';
    ctx.imageSmoothingQuality = 'high';

    const sprite = new Image();
    sprite.src = '/static/img/logo/sprite-favicon.png';

    this.init(ctx, sprite);
  },

  methods: {
    init(ctx, sprite) {
      if (this.index > 1) {
        // smile
        this.speed = 9000;
        this.index = 0;
      } else {
        // blink
        this.speed = 300;
      }

      ctx.clearRect(0, 0, 32, 32);
      ctx.drawImage(sprite, 32 * this.index++, 0, 32, 32, 0, 0, 16, 16); // eslint-disable-line

      const favOrig = Array.from(document.querySelectorAll('.favicon'));
      favOrig.forEach((favicon) => {
        const favClone = favicon.cloneNode(true);
        favClone.setAttribute('href', ctx.canvas.toDataURL('image/png', 1));
        favicon.parentNode.replaceChild(favClone, favicon);
      });

      setTimeout(() => {
        this.init(ctx, sprite);
      }, this.speed);
    },
  },
};
</script>

<style lang="scss" scoped>
canvas {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Favicon.vue